/* eslint-disable import/no-unresolved */
import React from "react";
import OrderSuccess from "components/pages/user/checkout/shopCheckout/success-page";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopOrderSuccess = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <OrderSuccess {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopOrderSuccess);
